<template>
  <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
            <h4>Beheer u gebruikersrollen</h4>
            <p>U kunt uw gebruikersrollen beheren om specifieke rechten te configureren voor een rol. Hierdoor kunt u eenvoudig rechten toekennen aan een gebruiker op basis van de rollen welke deze gebruiker in uw omgeving aan dient te nemen.</p>
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">
      
      <v-flex xs12 md12 lg8 xl6 pt-2>          
          <v-widget :title="`Gebruikersrollen beheren ${selectedRoleName} `" class="" title-text-color="">
            <v-btn v-if="selectedUserRole" fab dark  color="accent" slot="button-top-right" @click="clearCurrent()">
                <v-icon dark>arrow_back</v-icon>
            </v-btn>                 
            <v-btn v-if="!selectedUserRole" fab dark  color="accent" slot="button-top-right" @click="newUserRole()">
                <v-icon dark>add</v-icon>
            </v-btn>           
            <v-layout slot="widget-content">
    <!---- ROLE LIST -------------------------------------------------------->              
                  <v-flex xs12 sm12 lg12 v-if="!selectedUserRole">
                    <v-card-text>
                    <v-list dense> 
                      <v-list-tile active-class="primary darken-2" @click="loadForm(role)" avatar v-for="role of allUserRoles" :key="role.id">
                          <v-list-tile-title><b>{{role.name}}</b> ({{role.users.length}} gebruikers)</v-list-tile-title>                                            
                      </v-list-tile>                 
                    </v-list>                
                    </v-card-text>
                  </v-flex>
    <!---- ROLE DETAILS -------------------------------------------------------->                  
                  <v-flex  v-if="selectedUserRole" px-3 py-3>          
      
                    <v-tabs v-model="selectedTab">
                      <v-tab key="app_rights">Applicatie rechten</v-tab>
                      <v-tab key="asset_group_rights" :disabled="!selectedUserRole.id">Rechten op assetgroepen</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="selectedTab">    
          <!---- APPLICATION ROLE TAB -------------------------------------------------------->                                      
                       <v-tab-item key="app_rights">      
                          <v-form style='margin-top:20px;'
                              mt-2
                              ref="form"
                              v-model="valid"
                              lazy-validation>
                              <v-flex>                                    
                              <v-text-field
                                  v-model="selectedUserRole.name"                     
                                  label="Naam"
                                  :rules="nameRules"
                                  :disabled="roleNameCanBeChanged"
                                  required
                              ></v-text-field>                                                                 
                              </v-flex>
                              <v-flex row xs12>     
                                <v-layout row wrap mt-4 style="min-height:400px">
                                  <v-flex xs12 md6 mb-4>
                                        <v-flex>
                                          <tool-tip-icon text="Iedereen met de toegewezen rol kan de onderstaande handelingen verrichten"></tool-tip-icon>                                                                                                             
                                          Rol beschikt over onderstaande rechten
                                        </v-flex>
                                        <v-flex v-for="permission of selectedUserRolePermissions" :key="permission.id" pl-3>
                                          <v-chip label>
                                              <v-icon left >label</v-icon>
                                                {{permission.name}} 
                                              <v-icon class="fas fa-times" @click="removePermissionFromRole(permission)" right></v-icon>                 
                                          </v-chip>                                                                                                                                       
                                        </v-flex>
                                        <v-flex v-if="selectedUserRolePermissions.length==0" pl-4>
                                          <i>Geen rechten ingesteld voor rol</i>
                                        </v-flex>
                                  </v-flex>                                                  
                                  <v-flex xs12 md6>
                                      <v-layout column>
                                        <v-flex mb-1> 
                                          <tool-tip-icon text="Klik op een rechten veld om deze toe te voegen aan geselecteerde rechten </br> Sla deze daarna op"></tool-tip-icon>
                                          Beschikbare rechten:
                                        </v-flex>      
                                        <v-flex pl-3>                                                                      
                                          <v-text-field                      
                                              @keyup="searchRolePermissions(compObj)"
                                              v-model="searchText"
                                              prepend-inner-icon="fas fa-search"
                                              dense
                                              label="Zoek door rechten..."
                                              solo                                      
                                          >                                                          
                                          </v-text-field>                                                           
                                        </v-flex>                                             
                                        <v-flex v-for="permission of unselectedRolePermissions" :key="permission.id" pl-3 >
                                          <v-chip label outline @click="addRolePermission(permission)">
                                            <v-icon left>label</v-icon>
                                              {{permission.name}}
                                          </v-chip>                                                                                                                                       
                                        </v-flex>     
                                        <v-pagination
                                            v-model="userRolePermissionsPagination.current_page"
                                            :length="userRolePermissionsPagination.total_pages"                           
                                            @input="loadPage">
                                        </v-pagination>                                                                 
                                      </v-layout>
                                  </v-flex>       
                                </v-layout>
                              </v-flex>                        
                              <v-flex row >                  
                              <v-layout >
                                  <v-btn                          
                                      color=""                      
                                      @click="clearCurrent"> 
                                      annuleren
                                  </v-btn>                                                                                                         
                                  <v-spacer></v-spacer>                                                  
                                  <v-btn                                                
                                      :disabled="!valid"
                                      color="success"
                                      @click="saveForm">
                                      Opslaan
                                  </v-btn>                        
                              </v-layout>                                                                    
                              </v-flex>                 
                          </v-form>
                       </v-tab-item>
          <!---- ASSETGROUP RIGHTS TAB -------------------------------------------------------->                                                             
                       <v-tab-item key="asset_group_rights">     
                         <div style='margin-top:20px;'>
                            <v-flex v-if="!showAssetGroupConfigurator">
                                <p>Op dit moment zijn alle assetgroepen zichtbaar voor deze rol. Mocht je voor deze rol alleen bepaalde assetgroepen zichtbaar willen maken klik dan op de onderstaande knop. </p>
                                  <br>
                                <div style="margin-top:10px;">
                                  <v-btn color="primary" @click="showAssetGroupConfigurator=true">Assetgroep rechten instellen</v-btn> 
                                </div>
                            </v-flex>
                            <v-flex v-else>
                                <p>Stel hieronder in op welke assetgroepen zichtbaar moeten zijn voor de rol <b>{{selectedUserRole.name}}</b>.<br> 
                                   Let op! Als er geen assetgroepen zijn geselecteerd dan zijn alle groepen zichtbaar voor de rol.
                                </p>
                                <v-layout row wrap ml-2>
                                    <v-flex></v-flex>
                                    <v-flex md6 xs12 v-for="group in assetGroups" :key="group.id">
                                        <v-checkbox :label="group.name" v-model="selectedRoleAssetGroups[group.id]" value="value"></v-checkbox>
                                    </v-flex>                                
                                </v-layout>  
                                <v-flex row >                  
                                  <v-layout >
                                      <v-btn                          
                                          color=""                      
                                          @click="clearCurrent"> 
                                          annuleren
                                      </v-btn>                                                                                                         
                                      <v-spacer></v-spacer>                                                  
                                      <v-btn color="success" @click="saveAssetGroupsOnRole()">Opslaan</v-btn>             
                                  </v-layout>                                                                    
                                </v-flex>                                                                                               
                            </v-flex>
                         </div>
                       </v-tab-item>
                    </v-tabs-items>
                </v-flex>                                                  
            </v-layout>
          </v-widget>
        </v-flex>           
    </v-layout>
  </v-layout>
</template>
<script>

import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import DdPage from '../../components/global/DdPage'
import VWidget from "../../components/global/VWidget"
import TopInfoPanel from '../../components/global/TopInfoPanel'
import IconPicker from '../../components/form/IconPicker'
import ToolTipIcon from '../../components/global/ToolTipIcon'

export default {
  components: {
    VWidget,
    DdPage,
    IconPicker,
    TopInfoPanel,
    ToolTipIcon
  },
  data() {
    return  {
      selectedRoleAssetGroups:[],
      showAssetGroupConfigurator:false,
      selectedTab:0,
      compObj:this,
      searchText:"",
      valid:true,
      selectedUserRole:null,
      selectedUserRolePermissions:[],
      nameRules:[
        v => !!v || "Naam is verplicht"
      ]
    }
  }, 
  computed: {
    ...mapGetters({
      assetGroups:types.ASSET_GROUPS,
      allUserRoles: types.USER_ROLES,
      allUserRolePermissions: types.USER_ROLE_PERMISSIONS,
      userRolePermissionsPagination: types.USER_ROLE_PERMISSIONS_PAGINATION,      
    }),
    selectedRoleName(){
        return this.selectedUserRole ? " voor rol: "+this.selectedUserRole.name : ""
    },
    unselectedRolePermissions(){
      let result = []
      let selected = this.selectedUserRolePermissions
      let selectable = this.allUserRolePermissions
      
      selectable.forEach( (s1) => {        
          let found = false
          selected.forEach( (s2) => {        
              if(s1.id == s2.id){
                found = true
              }
          })
          if(!found){
            result.push(s1)
          }
      })
      return result
    },
    roleNameCanBeChanged(){
      return (this.selectedUserRole.id && this.selectedUserRole.name == "system_administrator") || (this.selectedUserRole.id && this.selectedUserRole.name == 'administrator') ? true : false
    },           
  },
  methods: {
    saveForm(){
      if(this.$refs.form.validate()) {
          
          this.$store.dispatch(types.SAVE_USER_ROLE, {data:this.selectedUserRole} ).then((res) => {        
            
              let data = {roleId:res.data.id, permissions:[]}
              this.selectedUserRolePermissions.forEach((perm) => {
                  data.permissions.push(perm.id)
              })

              this.$store.dispatch(types.SYNC_USER_ROLE_PERMISSIONS, data ).then((res) => {        

                // reload list after save         
                this.$notify(`Gebruikersgroep ${this.selectedUserRole.name} is opgeslagen`, {color:'success', timeout: 4000, icon:'check'})                                                          
                this.loadUserRoles()
                this.clearCurrent()                                        
              })
          })          
      }      
    },
    loadForm(userRole){
      // disconnect role reference from prop userRole
      let temp = {}
      Object.assign(temp, userRole)
      this.selectedUserRole = temp

      // disconnect permission references from selected userRole        
      this.selectedUserRolePermissions=[]
      this.selectedUserRole.permissions.forEach((permission) => {
          let temp = {}
          Object.assign(temp, permission)
          this.selectedUserRolePermissions.push( temp )
      })

      if(userRole.assetGroups.length > 0){
          this.selectedRoleAssetGroups=[]
          userRole.assetGroups.forEach((group) => {
            this.selectedRoleAssetGroups[group.id] = "value"
          })
          this.showAssetGroupConfigurator = true        
      }
      else
        this.showAssetGroupConfigurator = false
    }, 
    clearCurrent(){
      this.selectedUserRolePermissions = []
      this.selectedUserRole = null    
      this.selectedRoleAssetGroups=[]
      //this.$refs.form.reset()
    },
    saveAssetGroupsOnRole(){
       let groups = []
       for(let i in this.selectedRoleAssetGroups){
          if(this.selectedRoleAssetGroups[i] == "value")
            groups.push(i)
       }
       this.$store.dispatch(types.SAVE_ASSET_GROUPS_ON_ROLE,{assetGroups:groups, userRoleId:this.selectedUserRole.id}).then(()=>{         
         this.clearCurrent()
         this.loadUserRoles()

       })
    },
    newUserRole(){
      this.selectedUserRole = {id:"",name:""}       
    },
    loadUserRoles(){
      this.$store.dispatch(types.USER_ROLES,{params:{include:"users,permissions,assetGroups"}});
    },
    loadUserPermissions(){
      if(this.allUserRolePermissions.length==0){
        this.$store.dispatch(types.USER_ROLE_PERMISSIONS,{})
      }
    },  
    loadAssetGroups(){
        this.$store.dispatch(types.ASSET_GROUPS,{params:{per_page:200}});
    },
    removePermissionFromRole(removePermission){
      let result = []
      this.selectedUserRolePermissions.forEach((permission) => {
          if(permission.id != removePermission.id){
            result.push(permission)        
          }
      })
      this.selectedUserRolePermissions = result
    },
    addRolePermission(permission){
      this.selectedUserRolePermissions.push(permission);
    },
    loadPage(pageNr, fromDebounce=false){                
        // first set the current page
        this.currentPage=pageNr;
        
        // if entered from search and charlength is 1 or 2 do nothing
        if(fromDebounce && this.searchText.length == 1 || fromDebounce && this.searchText.length == 2){
            return;
        }
        // if entered from search and charlength is 0 reload all custom fields
        else if(fromDebounce && this.searchText.length == 0){
            this.$store.dispatch(types.USER_ROLE_PERMISSIONS, {params:{page:pageNr}})                
        }                
        // if searchlength is more then 2 always use search (so pagination works on search)
        else if(this.searchText.length > 2){
            this.$store.dispatch(types.USER_ROLE_PERMISSIONS_SEARCH, {data:{value:this.searchText},params:{page:pageNr}})
        }
        // default... pagination on all custom fields
        else{
            this.$store.dispatch(types.USER_ROLE_PERMISSIONS, {params:{page:pageNr}} ) 
        }                    
    },
    searchRolePermissions: _.debounce( (compObj)=>{    
        compObj.loadPage(1, true);
    },300),       
  },
  mounted() {
    this.clearCurrent();
    this.loadUserRoles();
    this.loadUserPermissions();
    this.loadAssetGroups();
    

    this.$store.dispatch(types.CURRENT_BREADCRUMBS, [
      {text: 'Home', href: '/', disabled: false},
      {text: 'Instellingen', href: '/settings', disabled: false},
      {text: 'Gebruikersrollen', href: '/settings/user-roles', disabled: false},
      // {text: 'FLU0000001', disabled: true},
    ])
    this.$store.dispatch(types.BACKGROUND_ICON, 'cogs');
  },  
  beforeDestroy(){
    this.$store.dispatch(types.BACKGROUND_ICON, null);
  }
}
</script>
<style>
.dd-detail-list li{
  list-style-type: none;
  padding-bottom: 4px;
  padding-left: 4px;
  border-bottom: 1px solid black;
  background-color: blue-gey lighten-5;
}
</style>
